import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import { v4 as uuid4 } from 'uuid';

import { environment } from '../../../../environments/environment';
import { LoggingService } from '../../../services/logging.service';
import { FederalLawFilter } from '../models/federal-law-filter';
import { AlgoritmTypeFilter } from '../models/algoritm-type-filter';

const API_SERVER = environment.apiServer;
const MODULE_PATH = 'TakomaClient.src.app.modules.home.services.AuctionFilterService';

@Injectable()
export class AuctionFilterService {

  constructor(
    private _http: HttpClient,
    private _loggingService: LoggingService
  ) { }

  // Получение списка ФЗ
  getFederalLawList(): Observable<FederalLawFilter[]> {
    const xid = uuid4();
    const qualName = `${MODULE_PATH}.getFederalLawList`;
    const description = '[Reactive] Получение списка федеральных законов';

    this._loggingService.logStart(xid, qualName, null, `${description} начато`);

    return this._http.get<FederalLawFilter[]>(`${API_SERVER}/federalLaw`)
      .do(() => {
        this._loggingService.logFinish(xid, qualName, null, `${description} завершено`);
      })
      .catch(error => {
        this._loggingService.logError(xid, qualName, error, null, `${description} завершено с ошибкой`);
        return Observable.throw(error);
      });
  }

  // Получение списка алгоритмов
  getAlgorithmTypeList(): Observable<AlgoritmTypeFilter[]> {
    const xid = uuid4();
    const qualName = `${MODULE_PATH}.getAlgorithmTypeList`;
    const description = '[Reactive] Получение списка типов алгоритмов';

    this._loggingService.logStart(xid, qualName, null, `${description} начато`);

    return this._http.get<AlgoritmTypeFilter[]>(`${API_SERVER}/algoritmType`)
      .do(() => {
        this._loggingService.logFinish(xid, qualName, null, `${description} завершено`);
      })
      .catch(error => {
        this._loggingService.logError(xid, qualName, error, null, `${description} завершено с ошибкой`);
        return Observable.throw(error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/home/services/home-auction-filter.service.ts